export const SUPER_SLOW = 2
export const SLOW = 1.6
export const NORMAL = 1.3
export const FAST = 1
export const SUPER_FAST = 0.8

export default {
  SUPER_SLOW,
  SLOW,
  NORMAL,
  FAST,
  SUPER_FAST
}
